import React, { useState, memo, Component } from 'react';
import { Code, Save, Play, CheckCircle, Edit, Rocket, Plus, Search, Settings, FileText, Layers, Shield, Database, GitBranch, ChevronRight, ArrowRight, ChevronDown, X, Eye, MessageSquare, AlertTriangle, Clock, Users, Zap, Tag } from 'lucide-react';
interface BuildProps {
  userRole: 'Program Manager' | 'Founder';
}
const Build: React.FC<BuildProps> = ({
  userRole
}) => {
  const [selectedAgent, setSelectedAgent] = useState('transcript-analyst-v1.1');
  const [activeSection, setActiveSection] = useState('overview');
  const [activeTab, setActiveTab] = useState('create');
  const [isRunningTest, setIsRunningTest] = useState(false);
  const [testCompleted, setTestCompleted] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [showAgentSelector, setShowAgentSelector] = useState(false);
  const handleRunTest = () => {
    setIsRunningTest(true);
    setTimeout(() => {
      setIsRunningTest(false);
      setTestCompleted(true);
    }, 3000);
  };
  const handleSubmit = () => {
    setSubmitSuccess(true);
    setTimeout(() => {
      setSubmitSuccess(false);
    }, 3000);
  };
  const handleSelectAgent = (agentId: string) => {
    setSelectedAgent(agentId);
    setShowAgentSelector(false);
  };
  return <div className="w-full h-full bg-gray-50" data-id="element-245">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-246">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-247">
          <div className="flex items-center" data-id="element-248">
            <h1 className="text-xl font-semibold text-gray-800" data-id="element-249">
              Agent Development Environment
            </h1>
            <div className="mx-4 h-6 w-px bg-gray-200" data-id="element-250"></div>
            <div className="relative" data-id="element-251">
              <button onClick={() => setShowAgentSelector(!showAgentSelector)} className="flex items-center space-x-2 text-gray-700 hover:text-gray-900 font-medium px-3 py-1.5 rounded-md hover:bg-gray-100" data-id="element-252">
                <Code size={16} className="text-blue-600" data-id="element-253" />
                <span data-id="element-254">Transcript Analyst v1.1</span>
                <ChevronDown size={16} data-id="element-255" />
              </button>
              {showAgentSelector && <div className="absolute top-full left-0 mt-1 w-72 bg-white rounded-md shadow-lg border border-gray-200 z-20" data-id="element-256">
                  <div className="p-2 border-b border-gray-100" data-id="element-257">
                    <div className="relative" data-id="element-258">
                      <Search className="absolute left-2.5 top-2.5 text-gray-400" size={14} data-id="element-259" />
                      <input type="text" placeholder="Search agents..." className="w-full pl-8 pr-3 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-260" />
                    </div>
                  </div>
                  <div className="max-h-80 overflow-y-auto p-1" data-id="element-261">
                    <div className={`p-2 ${selectedAgent === 'transcript-analyst-v1.1' ? 'bg-blue-50 border-blue-200' : 'hover:bg-gray-50'} rounded-md mb-1 cursor-pointer flex items-center`} onClick={() => handleSelectAgent('transcript-analyst-v1.1')} data-id="element-262">
                      <Code size={16} className="text-blue-600 mr-2" data-id="element-263" />
                      <div data-id="element-264">
                        <p className="text-sm font-medium text-gray-800" data-id="element-265">
                          Transcript Analyst v1.1
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-266">
                          Draft • Discovery
                        </p>
                      </div>
                    </div>
                    <div className={`p-2 ${selectedAgent === 'transcript-analyst-v1' ? 'bg-blue-50 border-blue-200' : 'hover:bg-gray-50'} rounded-md mb-1 cursor-pointer flex items-center`} onClick={() => handleSelectAgent('transcript-analyst-v1')} data-id="element-267">
                      <Code size={16} className="text-blue-600 mr-2" data-id="element-268" />
                      <div data-id="element-269">
                        <p className="text-sm font-medium text-gray-800" data-id="element-270">
                          Transcript Analyst
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-271">
                          v1.0 Published • Discovery
                        </p>
                      </div>
                    </div>
                    <div className={`p-2 ${selectedAgent === 'stakeholder-mapping' ? 'bg-blue-50 border-blue-200' : 'hover:bg-gray-50'} rounded-md mb-1 cursor-pointer flex items-center`} onClick={() => handleSelectAgent('stakeholder-mapping')} data-id="element-272">
                      <Code size={16} className="text-blue-600 mr-2" data-id="element-273" />
                      <div data-id="element-274">
                        <p className="text-sm font-medium text-gray-800" data-id="element-275">
                          Stakeholder Mapping
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-276">
                          v1.2 Published • Discovery
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="p-2 border-t border-gray-100" data-id="element-277">
                    <button className="w-full flex items-center justify-center space-x-2 text-blue-600 hover:text-blue-800 font-medium px-3 py-1.5 rounded-md hover:bg-blue-50" data-id="element-278">
                      <Plus size={16} data-id="element-279" />
                      <span data-id="element-280">Create new agent</span>
                    </button>
                  </div>
                </div>}
            </div>
            <div className="flex items-center ml-6" data-id="element-281">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-282">
                Draft
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-283">
            <button onClick={handleSubmit} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md flex items-center transition-colors" data-id="element-284">
              <Save size={16} className="mr-2" data-id="element-285" /> Save Changes
            </button>
          </div>
        </div>
        {/* Main Navigation */}
        <div className="flex border-t border-gray-200 px-6" data-id="element-286">
          <button className={`px-4 py-3 font-medium text-sm border-b-2 ${activeTab === 'create' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} onClick={() => setActiveTab('create')} data-id="element-287">
            <div className="flex items-center" data-id="element-288">
              <Edit size={16} className="mr-2" data-id="element-289" /> Create
            </div>
          </button>
          <button className={`px-4 py-3 font-medium text-sm border-b-2 ${activeTab === 'run' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} onClick={() => setActiveTab('run')} data-id="element-290">
            <div className="flex items-center" data-id="element-291">
              <Rocket size={16} className="mr-2" data-id="element-292" /> Run
            </div>
          </button>
        </div>
      </div>
      {/* Main Content */}
      <div className="flex h-[calc(100vh-12rem)]" data-id="element-293">
        {activeTab === 'create' && <>
            {/* Sidebar Navigation */}
            <div className="w-64 bg-white border-r border-gray-200 h-full overflow-auto" data-id="element-294">
              <nav className="p-4" data-id="element-295">
                <div className="space-y-1" data-id="element-296">
                  <NavItem icon={<FileText size={18} data-id="element-298" />} title="Overview" isActive={activeSection === 'overview'} onClick={() => setActiveSection('overview')} data-id="element-297" />
                  <NavItem icon={<Layers size={18} data-id="element-300" />} title="Inputs & Outputs" isActive={activeSection === 'inputs'} onClick={() => setActiveSection('inputs')} data-id="element-299" />
                  <NavItem icon={<Database size={18} data-id="element-302" />} title="Context Requirements" isActive={activeSection === 'context'} onClick={() => setActiveSection('context')} data-id="element-301" />
                  <NavItem icon={<Shield size={18} data-id="element-304" />} title="Guardrails" isActive={activeSection === 'guardrails'} onClick={() => setActiveSection('guardrails')} data-id="element-303" />
                  <NavItem icon={<Clock size={18} data-id="element-306" />} title="Memory & Learning" isActive={activeSection === 'memory'} onClick={() => setActiveSection('memory')} data-id="element-305" />
                  <NavItem icon={<div size={18} data-id="element-308" />} title="Tools & Permissions" isActive={activeSection === 'tools'} onClick={() => setActiveSection('tools')} data-id="element-307" />
                  <NavItem icon={<GitBranch size={18} data-id="element-310" />} title="Versioning" isActive={activeSection === 'versioning'} onClick={() => setActiveSection('versioning')} data-id="element-309" />
                </div>
              </nav>
            </div>
            {/* Content Area */}
            <div className="flex-1 overflow-auto p-6" data-id="element-311">
              {activeSection === 'overview' && <div className="space-y-6" data-id="element-312">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-313">
                    <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-314">
                      Basic Information
                    </h2>
                    <div className="space-y-4" data-id="element-315">
                      <FormField label="Name" value="Transcript Analyst" placeholder="Enter agent name" data-id="element-316" />
                      <FormField label="Short description" value="Analyzes customer interview transcripts to extract key insights with citations and confidence levels." placeholder="Enter short description" multiline data-id="element-317" />
                      <div className="grid grid-cols-2 gap-4" data-id="element-318">
                        <FormSelect label="Category" value="Discovery" options={['Discovery', 'Validation', 'Messaging', 'Assets']} data-id="element-319" />
                        <FormSelect label="Intended users" value="All users" options={['All users', 'Founders only', 'Program Managers only']} data-id="element-320" />
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-321">
                    <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-322">
                      Agent Properties
                    </h2>
                    <div className="space-y-4" data-id="element-323">
                      <div className="grid grid-cols-3 gap-4" data-id="element-324">
                        <PropertyCard icon={<MessageSquare size={18} data-id="element-326" />} title="Conversation Type" value="Single-turn" color="blue" data-id="element-325" />
                        <PropertyCard icon={<Zap size={18} data-id="element-328" />} title="Average Response Time" value="~3 seconds" color="amber" data-id="element-327" />
                        <PropertyCard icon={<Tag size={18} data-id="element-330" />} title="Tags" value="Transcript, Analysis, Insights" color="emerald" data-id="element-329" />
                      </div>
                    </div>
                  </div>
                </div>}
              {activeSection === 'inputs' && <div className="space-y-6" data-id="element-331">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-332">
                    <div className="flex justify-between items-center mb-4" data-id="element-333">
                      <h2 className="text-lg font-medium text-gray-800" data-id="element-334">
                        Required Artifacts
                      </h2>
                      <button className="px-3 py-1.5 text-sm bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 flex items-center" data-id="element-335">
                        <Plus size={16} className="mr-1" data-id="element-336" /> Add Artifact
                      </button>
                    </div>
                    <div className="space-y-3" data-id="element-337">
                      <ArtifactCard name="Transcript" description="Customer interview transcript in text format" required data-id="element-338" />
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-339">
                    <div className="flex justify-between items-center mb-4" data-id="element-340">
                      <h2 className="text-lg font-medium text-gray-800" data-id="element-341">
                        Optional Fields
                      </h2>
                      <button className="px-3 py-1.5 text-sm bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 flex items-center" data-id="element-342">
                        <Plus size={16} className="mr-1" data-id="element-343" /> Add Field
                      </button>
                    </div>
                    <div className="space-y-3" data-id="element-344">
                      <ArtifactCard name="Focus" description="Specific topics to focus on during analysis" required={false} data-id="element-345" />
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-346">
                    <div className="flex justify-between items-center mb-4" data-id="element-347">
                      <h2 className="text-lg font-medium text-gray-800" data-id="element-348">
                        Output Types
                      </h2>
                      <button className="px-3 py-1.5 text-sm bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 flex items-center" data-id="element-349">
                        <Plus size={16} className="mr-1" data-id="element-350" /> Add Output
                      </button>
                    </div>
                    <div className="space-y-3" data-id="element-351">
                      <OutputTypeCard name="Insight Cards" description="Key insights with confidence levels and citations" enabled data-id="element-352" />
                      <OutputTypeCard name="Summary" description="Concise summary of key findings" enabled data-id="element-353" />
                    </div>
                  </div>
                </div>}
              {activeSection === 'guardrails' && <div className="space-y-6" data-id="element-354">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-355">
                    <div className="flex justify-between items-center mb-4" data-id="element-356">
                      <h2 className="text-lg font-medium text-gray-800" data-id="element-357">
                        Guardrails
                      </h2>
                      <button className="px-3 py-1.5 text-sm bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 flex items-center" data-id="element-358">
                        <Plus size={16} className="mr-1" data-id="element-359" /> Add Guardrail
                      </button>
                    </div>
                    <div className="space-y-4" data-id="element-360">
                      <GuardrailCard title="Require citations per insight" description="Every insight must include a direct quote from the transcript." enabled data-id="element-361" />
                      <GuardrailCard title="Avoid recommendations without evidence" description="Do not suggest actions without supporting evidence in the transcript." enabled data-id="element-362" />
                      <GuardrailCard title="PHI/PII reminder" description="Display a reminder that this is training-only data and should not include PHI/PII." enabled data-id="element-363" />
                      <GuardrailCard title="Flag low confidence insights" description="Clearly mark insights below 50% confidence and explain reasoning." enabled={false} draft data-id="element-364" />
                    </div>
                  </div>
                </div>}
              {activeSection === 'versioning' && <div className="space-y-6" data-id="element-365">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-366">
                    <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-367">
                      Version Information
                    </h2>
                    <div className="space-y-4" data-id="element-368">
                      <FormField label="Version label" value="v1.1" placeholder="e.g., v1.0, v1.1, v2.0" data-id="element-369" />
                      <FormField label="Change notes" value="Added guardrail to flag low confidence insights with explanations. Improved citation extraction algorithm." placeholder="Describe what changed in this version" multiline data-id="element-370" />
                    </div>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-371">
                    <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-372">
                      Version History
                    </h2>
                    <div className="space-y-4" data-id="element-373">
                      <div className="flex items-start border-l-2 border-blue-500 pl-4 py-1" data-id="element-374">
                        <div className="mr-4" data-id="element-375">
                          <div className="text-sm font-medium text-gray-800" data-id="element-376">
                            v1.1
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-377">
                            Current draft
                          </div>
                        </div>
                        <div className="flex-1" data-id="element-378">
                          <div className="text-sm text-gray-800" data-id="element-379">
                            Added guardrail to flag low confidence insights with
                            explanations. Improved citation extraction
                            algorithm.
                          </div>
                        </div>
                      </div>
                      <div className="flex items-start border-l-2 border-gray-300 pl-4 py-1" data-id="element-380">
                        <div className="mr-4" data-id="element-381">
                          <div className="text-sm font-medium text-gray-800" data-id="element-382">
                            v1.0
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-383">
                            Published 2 weeks ago
                          </div>
                        </div>
                        <div className="flex-1" data-id="element-384">
                          <div className="text-sm text-gray-800" data-id="element-385">
                            Initial release
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Placeholder content for other sections */}
              {activeSection === 'context' && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-386">
                  <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-387">
                    Context Requirements
                  </h2>
                  <p className="text-gray-500" data-id="element-388">
                    Configure context requirements for your agent here.
                  </p>
                </div>}
              {activeSection === 'memory' && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-389">
                  <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-390">
                    Memory & Learning
                  </h2>
                  <p className="text-gray-500" data-id="element-391">
                    Configure memory and learning capabilities for your agent
                    here.
                  </p>
                </div>}
              {activeSection === 'tools' && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-392">
                  <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-393">
                    Tools & Permissions
                  </h2>
                  <p className="text-gray-500" data-id="element-394">
                    Configure tools and permissions for your agent here.
                  </p>
                </div>}
            </div>
          </>}
        {activeTab === 'run' && <div className="flex flex-1 h-full" data-id="element-395">
            <div className="flex-1 p-6 overflow-auto" data-id="element-396">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-397">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-398">
                  <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-399">
                    Test Agent
                  </h2>
                  <div className="space-y-4" data-id="element-400">
                    <div className="flex items-center justify-between mb-2" data-id="element-401">
                      <p className="text-sm text-gray-600" data-id="element-402">
                        Test your agent with real data before publishing
                      </p>
                      <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full" data-id="element-403">
                        ~60 credits per run
                      </span>
                    </div>
                    <FormSelect label="Select venture" value="CardioSense" options={['CardioSense', 'MedBridge AI', 'NeuroNote']} data-id="element-404" />
                    <FormSelect label="Artifact" value="CRN-001" options={['CRN-001', 'CRN-002', 'CRN-003']} data-id="element-405" />
                    <button onClick={handleRunTest} className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-md flex items-center justify-center transition-colors" disabled={isRunningTest} data-id="element-406">
                      {isRunningTest ? <>
                          <div className="animate-spin mr-2 h-4 w-4 border-2 border-white border-t-transparent rounded-full" data-id="element-407"></div>
                          Running test...
                        </> : <>
                          <Play size={16} className="mr-2" data-id="element-408" /> Test agent
                        </>}
                    </button>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-409">
                  <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-410">
                    Run in Venture
                  </h2>
                  <div className="space-y-4" data-id="element-411">
                    <p className="text-sm text-gray-600" data-id="element-412">
                      Run this agent in a venture to analyze real data and
                      generate insights
                    </p>
                    <div className="p-4 bg-blue-50 border border-blue-100 rounded-md" data-id="element-413">
                      <div className="flex items-start" data-id="element-414">
                        <AlertTriangle size={16} className="text-blue-600 mr-2 mt-0.5" data-id="element-415" />
                        <div data-id="element-416">
                          <p className="text-sm text-blue-800 font-medium" data-id="element-417">
                            Save your changes first
                          </p>
                          <p className="text-xs text-blue-700" data-id="element-418">
                            You have unsaved changes. Save your agent before
                            running it in a venture.
                          </p>
                        </div>
                      </div>
                    </div>
                    <button className="w-full py-2.5 bg-gray-200 text-gray-500 rounded-md flex items-center justify-center cursor-not-allowed" disabled data-id="element-419">
                      <Rocket size={16} className="mr-2" data-id="element-420" /> Run in venture
                    </button>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 lg:col-span-2" data-id="element-421">
                  <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-422">
                    Publish to Marketplace
                  </h2>
                  <div className="space-y-4" data-id="element-423">
                    <div className="flex items-start space-x-4" data-id="element-424">
                      <div className="flex-1" data-id="element-425">
                        <h3 className="text-md font-medium text-gray-800 mb-1" data-id="element-426">
                          Ready to submit
                        </h3>
                        <p className="text-sm text-gray-600 mb-4" data-id="element-427">
                          This agent will be submitted to the Marketplace for
                          approval. Program Managers will review before it's
                          available to all users.
                        </p>
                        <button onClick={handleSubmit} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-428">
                          Submit to Marketplace
                        </button>
                      </div>
                      <div className="w-1/3" data-id="element-429">
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-md" data-id="element-430">
                          <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-431">
                            Submission Checklist
                          </h4>
                          <ul className="space-y-2" data-id="element-432">
                            <li className="flex items-start" data-id="element-433">
                              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" data-id="element-434" />
                              <span className="text-sm text-gray-600" data-id="element-435">
                                Basic information complete
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-436">
                              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" data-id="element-437" />
                              <span className="text-sm text-gray-600" data-id="element-438">
                                Required artifacts defined
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-439">
                              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" data-id="element-440" />
                              <span className="text-sm text-gray-600" data-id="element-441">
                                Output types configured
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-442">
                              <AlertTriangle size={16} className="text-amber-500 mr-2 mt-0.5" data-id="element-443" />
                              <span className="text-sm text-gray-600" data-id="element-444">
                                Test run recommended
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {submitSuccess && <div className="p-4 bg-green-50 border border-green-200 rounded-md flex items-start" data-id="element-445">
                        <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" data-id="element-446" />
                        <div data-id="element-447">
                          <p className="text-sm text-green-800 font-medium" data-id="element-448">
                            Submitted successfully
                          </p>
                          <p className="text-xs text-green-700" data-id="element-449">
                            Status: Pending approval
                          </p>
                        </div>
                      </div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-80 bg-white border-l border-gray-200 overflow-auto" data-id="element-450">
              <div className="p-4 border-b border-gray-200" data-id="element-451">
                <h3 className="text-md font-medium text-gray-800" data-id="element-452">
                  Test Results
                </h3>
              </div>
              {isRunningTest ? <div className="p-4" data-id="element-453">
                  <div className="p-4 bg-blue-50 border border-blue-200 rounded-md" data-id="element-454">
                    <div className="flex items-center justify-between mb-2" data-id="element-455">
                      <h3 className="text-sm font-medium text-blue-800" data-id="element-456">
                        Running test...
                      </h3>
                      <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full" data-id="element-457">
                        Est. 60 credits
                      </span>
                    </div>
                    <div className="w-full h-2 bg-white rounded-full overflow-hidden" data-id="element-458">
                      <div className="h-2 bg-blue-500 rounded-full" style={{
                  width: '60%',
                  animation: 'indeterminate-progress 2s infinite linear'
                }} data-id="element-459"></div>
                    </div>
                    <p className="text-xs text-blue-700 mt-2" data-id="element-460">
                      Processing transcript data...
                    </p>
                  </div>
                </div> : testCompleted ? <div className="p-4" data-id="element-461">
                  <div className="p-4 bg-green-50 border border-green-200 rounded-md mb-4 flex items-start" data-id="element-462">
                    <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" data-id="element-463" />
                    <div data-id="element-464">
                      <p className="text-sm text-green-800 font-medium" data-id="element-465">
                        Test completed
                      </p>
                      <p className="text-xs text-green-700" data-id="element-466">
                        5 insights generated • 58 credits used
                      </p>
                    </div>
                  </div>
                  <h4 className="text-sm font-medium text-gray-700 mb-2 px-1" data-id="element-467">
                    Generated Insights
                  </h4>
                  <div className="space-y-3" data-id="element-468">
                    <InsightCard title="Transportation barriers drive week 2–3 no-shows" confidence="High" citation="Transportation is number one… Weeks two and three are where no-shows spike." data-id="element-469" />
                    <InsightCard title="Patients confused about medication schedule" confidence="Medium" citation="Many don't understand when to take their pills... especially with the twice daily regimen." data-id="element-470" />
                    <InsightCard title="Need for simplified educational materials" confidence="High" citation="The current materials are too complex. Patients need simpler explanations with visuals." data-id="element-471" />
                  </div>
                  <div className="mt-4 flex justify-center" data-id="element-472">
                    <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-473">
                      View all 5 insights
                    </button>
                  </div>
                  <div className="mt-6 px-1" data-id="element-474">
                    <button className="w-full py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md flex items-center justify-center transition-colors" data-id="element-475">
                      <Eye size={16} className="mr-2" data-id="element-476" /> Use as Marketplace
                      example
                    </button>
                  </div>
                </div> : <div className="p-8 flex flex-col items-center justify-center text-center text-gray-500" data-id="element-477">
                  <Play size={40} className="text-gray-300 mb-3" data-id="element-478" />
                  <p className="text-sm" data-id="element-479">No test results yet</p>
                  <p className="text-xs mt-1" data-id="element-480">Run a test to see results here</p>
                </div>}
            </div>
          </div>}
      </div>
    </div>;
};
// Component for navigation items in the sidebar
const NavItem = ({
  icon,
  title,
  isActive,
  onClick
}) => <button className={`w-full flex items-center space-x-2 px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'}`} onClick={onClick} data-id="element-481">
    <span className={isActive ? 'text-blue-600' : 'text-gray-500'} data-id="element-482">{icon}</span>
    <span className="font-medium text-sm" data-id="element-483">{title}</span>
    {isActive && <ChevronRight size={16} className="ml-auto" data-id="element-484" />}
  </button>;
// Component for form fields
const FormField = ({
  label,
  value,
  placeholder,
  multiline = false
}) => <div data-id="element-485">
    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-486">
      {label}
    </label>
    {multiline ? <textarea className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" rows={3} placeholder={placeholder} defaultValue={value} data-id="element-487" /> : <input type="text" className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder={placeholder} defaultValue={value} data-id="element-488" />}
  </div>;
// Component for select fields
const FormSelect = ({
  label,
  value,
  options
}) => <div data-id="element-489">
    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-490">
      {label}
    </label>
    <select className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-491">
      {options.map((option, index) => <option key={index} selected={option === value} data-id="element-492">
          {option}
        </option>)}
    </select>
  </div>;
// Component for property cards
const PropertyCard = ({
  icon,
  title,
  value,
  color
}) => {
  const colors = {
    blue: 'bg-blue-50 text-blue-800 border-blue-200',
    amber: 'bg-amber-50 text-amber-800 border-amber-200',
    emerald: 'bg-emerald-50 text-emerald-800 border-emerald-200'
  };
  return <div className={`p-4 rounded-md border ${colors[color]}`} data-id="element-493">
      <div className="flex items-center mb-2" data-id="element-494">
        <span className={`mr-2 ${color === 'blue' ? 'text-blue-600' : color === 'amber' ? 'text-amber-600' : 'text-emerald-600'}`} data-id="element-495">
          {icon}
        </span>
        <span className="text-sm font-medium" data-id="element-496">{title}</span>
      </div>
      <div className="text-sm" data-id="element-497">{value}</div>
    </div>;
};
// Component for artifact cards
const ArtifactCard = ({
  name,
  description,
  required
}) => <div className="p-3 border border-gray-200 rounded-md bg-white hover:bg-gray-50" data-id="element-498">
    <div className="flex items-center justify-between" data-id="element-499">
      <div data-id="element-500">
        <div className="flex items-center" data-id="element-501">
          <span className="text-gray-800 font-medium" data-id="element-502">{name}</span>
          {required && <span className="ml-2 text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-503">
              Required
            </span>}
        </div>
        <p className="text-xs text-gray-500 mt-1" data-id="element-504">{description}</p>
      </div>
      <button className="text-red-600 hover:text-red-800" data-id="element-505">
        <X size={16} data-id="element-506" />
      </button>
    </div>
  </div>;
// Component for output type cards
const OutputTypeCard = ({
  name,
  description,
  enabled
}) => <div className="p-3 border border-gray-200 rounded-md bg-white hover:bg-gray-50" data-id="element-507">
    <div className="flex items-center justify-between" data-id="element-508">
      <div data-id="element-509">
        <div className="flex items-center" data-id="element-510">
          <input type="checkbox" className="mr-2" checked={enabled} data-id="element-511" />
          <span className="text-gray-800 font-medium" data-id="element-512">{name}</span>
        </div>
        <p className="text-xs text-gray-500 mt-1 ml-6" data-id="element-513">{description}</p>
      </div>
    </div>
  </div>;
// Component for guardrail cards
const GuardrailCard = ({
  title,
  description,
  enabled,
  draft
}) => <div className={`p-4 border rounded-md ${draft ? 'border-dashed' : ''} ${enabled ? 'bg-white' : 'bg-gray-50'}`} data-id="element-514">
    <div className="flex items-center justify-between mb-1" data-id="element-515">
      <span className="text-gray-800 font-medium" data-id="element-516">{title}</span>
      <div className="flex items-center" data-id="element-517">
        {draft ? <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full mr-2" data-id="element-518">
            Draft
          </span> : enabled ? <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full mr-2" data-id="element-519">
            Enabled
          </span> : <span className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 rounded-full mr-2" data-id="element-520">
            Disabled
          </span>}
        <button className={draft ? 'text-blue-600 hover:text-blue-800' : 'text-red-600 hover:text-red-800'} data-id="element-521">
          {draft ? 'Save' : 'Remove'}
        </button>
      </div>
    </div>
    <p className="text-sm text-gray-600" data-id="element-522">{description}</p>
  </div>;
// Component for insight cards in test results
const InsightCard = ({
  title,
  confidence,
  citation
}) => {
  const confidenceColor = confidence === 'High' ? 'bg-green-100 text-green-800' : confidence === 'Medium' ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800';
  return <div className="border border-gray-200 rounded-md p-3 bg-white" data-id="element-523">
      <h4 className="text-sm font-medium text-gray-800 mb-1" data-id="element-524">{title}</h4>
      <div className="flex justify-between mb-1" data-id="element-525">
        <span className={`text-xs py-0.5 px-2 ${confidenceColor} rounded-full`} data-id="element-526">
          {confidence} Confidence
        </span>
      </div>
      <div className="text-xs text-gray-600 mt-1 line-clamp-2" data-id="element-527">
        <span className="font-medium" data-id="element-528">Citation:</span> "{citation}"
      </div>
    </div>;
};
export default Build;